const cfdParcelDetailsReport = {
  label: "CFD Parcel Details Report",
  name: "cfdParcelDetailsReport",
  parameters: [
    {
      name: "db",
      label: "Database",
      type: "select",
      defaultValue: "cfd",
      options: [
        { key: "cfd", label: "cfd" },
        { key: "cfddev", label: "cfddev" },
        { key: "cfddev_staging", label: "cfddev_staging" },
      ],
    },
    {
      name: "district",
      label: "District",
      type: "dbfield",
      table: "District",
      keyField: "DistrictId",
      valueField: "Name",
      sort: {
        Name: "asc",
      },
      multiple: true,
    },
  ],
};

export default cfdParcelDetailsReport;
